import { Grid, Chip } from "@mui/material";
import CardButton from "../CardButton";

interface ProductCardProps {
    id: string;
    name: string;
    icon: React.ReactNode | ((color: string, isSelected?: boolean, isCard?: boolean, isDisabled?: boolean) => JSX.Element);
    product: string | undefined;
    userData: any;
    colors: any;
    smallCardButton: boolean;
    displayToCard: string;
    onClick: () => void;
}

export default function ProductCard({
    id,
    name,
    icon,
    product,
    userData,
    colors,
    smallCardButton,
    displayToCard,
    onClick,
}: ProductCardProps) {
    const planKey = {
        "1": "tr_balance",
        "2": "hp_balance",
        "3": "sr_balance",
        "4": "cr_balance",
        "5": "cm_balance",
        "6": "hv_balance",
        "7": "lw_balance",
    }[id] as keyof typeof userData.plan_balance;

    const planCompanyKey = {
        "1": "tr_count_company",
        "2": "hp_count_company",
        "3": "sr_count_company",
        "4": "cr_count_company",
        "5": "cm_count_company",
        "6": "hv_count_company",
        "7": "lw_count_company",
    }[id] as keyof typeof userData.plan_balance;

    const planUserKey = {
        "1": "tr_count_user",
        "2": "hp_count_user",
        "3": "sr_count_user",
        "4": "cr_count_user",
        "5": "cm_count_user",
        "6": "hv_count_user",
        "7": "lw_count_user",
    }[id] as keyof typeof userData.plan_balance;

    const balance = userData?.plan_balance?.[planKey] ?? 0;
    const count = userData?.company ? userData?.plan_balance?.[planCompanyKey] ?? 0 : userData?.plan_balance?.[planUserKey] ?? 0;
    const isDisabled = userData?.is_admin === false ? balance < 1 : false;    
    const reachedLimit =  balance < count;

    const color = isDisabled
        ? colors.EskimoGray
        : smallCardButton
            ? product === id
                ? colors.IceWhite
                : colors.WaterBlue
            : colors.WaterBlue;

    const backgroundColor = isDisabled
        ? colors.FogGray
        : smallCardButton
            ? product === id
                ? colors.WaterBlue
                : colors.LowBlue
            : colors.LoginBlue;

    const isTruckAndBus = id === "5";

    return (
        <Grid
            textAlign="center"
            style={{
                marginTop: ".1rem",
                display: displayToCard,
                flexDirection: !smallCardButton ? "column" : "row",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <CardButton
                name={name}
                icon={typeof icon === "function" ? icon(color, product === id, smallCardButton, isDisabled) : icon}
                color={color}
                backgroundColor={backgroundColor}
                onClick={onClick}
                small={smallCardButton}
                style={{
                    display: "flex",
                    flexDirection: isTruckAndBus ? "column" : "row",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            />

            {!smallCardButton && !userData?.is_admin && !userData?.is_staff && (
                <Chip
                    style={{ display: displayToCard, marginTop: "0.5rem" }}
                    color={reachedLimit ? "warning" : "info"}
                    label={
                        `${count} consultas realizadas de ${balance}`
                    }
                />
            )}
        </Grid>
    );
}
